export function mapNullToUndefined<T>(item: T | null) {
  return item ?? undefined;
}
